"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizResultRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const lion_1 = require("../../../icon/lion");
const star_1 = require("../../../icon/star");
const smile_1 = require("../../../icon/smile");
const button_1 = require("../../../component/input/button");
const QuizResultRenderer = ({ result, onReQuiz, onGoToList, }) => {
    const theme = (0, material_1.useTheme)();
    const handleReQuiz = (0, react_1.useCallback)(() => {
        if (onReQuiz) {
            onReQuiz();
        }
    }, [onReQuiz]);
    const renderInfo = (0, react_1.useMemo)(() => {
        const starCount = result.starCount;
        const isPerfect = result.isPerfect;
        const errorCount = result.questions.filter((q) => !q.isPerfect).length;
        const nextLevel = result.newLevel;
        if (nextLevel) {
            return {
                title: "Hooray! You did it!",
                subtitle: "All your animal friends are so proud of you!",
                saysTitle: "Amazing Job!",
                saysSubtitle: "Congrats! You finished all the book in this level​",
                starCount,
                actionText: "Read next level book!​",
                action: onGoToList,
            };
        }
        return isPerfect
            ? {
                title: "Hooray! You did it!",
                subtitle: "All your animal friends are so proud of you!",
                saysTitle: "Amazing Job!",
                saysSubtitle: starCount > 0
                    ? `${starCount} perfect stars! You are a quiz champion!`
                    : "You are a quiz champion!",
                starCount,
                actionText: "Read another book​",
                action: onGoToList,
            }
            : {
                title: "You almost did it!",
                subtitle: "Your animials friends are waiting for you to correct them!​",
                saysTitle: `You have ${result.questions.length - errorCount}/${result.questions.length} correct`,
                saysSubtitle: "Go back fix the them!​",
                starCount,
                actionText: "Fix mistakes",
                action: handleReQuiz,
            };
    }, [
        handleReQuiz,
        onGoToList,
        result.isPerfect,
        result.newLevel,
        result.questions,
        result.starCount,
    ]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 4, width: "100%", minHeight: "100%", padding: 8, alignItems: "center", justifyContent: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", fontWeight: "bold", color: "tertiary", children: renderInfo.title }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: "tertiary", children: renderInfo.subtitle }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { minWidth: theme.spacing(50), direction: "column", spacing: 4, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", width: "100%", sx: {
                            background: theme.palette.gradient.card2,
                            borderRadius: theme.spacing(2),
                            border: `${theme.spacing(0.5)} solid ${theme.palette.custom.orange}`,
                        }, padding: 4, spacing: 2, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "center", spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: lion_1.LionIcon, sx: {
                                            fontSize: theme.spacing(4),
                                        } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", color: "textPrimary", fontWeight: theme.typography.fontWeightBold, children: "Says" })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", color: "tertiary", fontWeight: theme.typography.fontWeightBold, children: renderInfo.saysTitle }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: 1, children: [renderInfo.starCount > 0 &&
                                        Array.from({ length: renderInfo.starCount }).map((_, index) => ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: star_1.StarIcon, sx: {
                                                fontSize: theme.spacing(4),
                                                color: theme.palette.custom.orange,
                                            } }, index))), renderInfo.starCount === 0 && ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: smile_1.SmileIcon, sx: {
                                            fontSize: theme.spacing(4),
                                            color: theme.palette.custom.orange,
                                        } }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: "tertiary", children: renderInfo.saysSubtitle })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", color: "primary", onClick: renderInfo.action, fullWidth: true, children: renderInfo.actionText })] })] }));
};
exports.QuizResultRenderer = QuizResultRenderer;
